const TERM_SHEET_TYPES = {
  MonthlyTermSheet: "month",
  WeeklyTermSheet: "week",
};

const TERM_SHEET_PRICING_TYPES = {
  MONTHLY_TERM_SHEET: "Monthly",
  WEEKLY_TERM_SHEET: "Weekly",
};

const TERM_SHEET_INVERSE_PRICING_TYPES = {
  MONTHLY_TERM_SHEET: "WEEKLY_TERM_SHEET",
  WEEKLY_TERM_SHEET: "MONTHLY_TERM_SHEET",
};

export { TERM_SHEET_PRICING_TYPES, TERM_SHEET_INVERSE_PRICING_TYPES };

export default TERM_SHEET_TYPES;
